import React from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
class VerificationListSelection extends React.Component {
  constructor(props) {
    super(props);
    this.DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";

    this._handleApply = this._handleApply.bind(this);
  }

  _handleApply(event, picker) {
    // console.log("Start Date : " + picker.startDate.format(this.DATE_FORMAT));
  }
  render() {
    return (
      <ul className="nav navbar-right panel_toolbox">
        <li style={{ paddingRight: "10px" }}>
          {/* <DateRangePicker startDate="1/1/2018" onApply={this._handleApply} showDropdowns className="pull-right" style={{background: "#fff", cursor: "pointer", padding: "5px 10px", border: "1px solid #ccc"}}>
                            <button >
                                <i className="glyphicon glyphicon-calendar fa fa-calendar"></i>
                                <span></span> <b className="caret"></b>
                            </button>
                        </DateRangePicker> */}
        </li>
        {/* <li>
                        <button data-toggle="dropdown" className="btn btn-default dropdown-toggle" type="button" aria-expanded="true"><span>All <span className="caret"></span>
                </span></button>
                        {<ul role="menu" className="dropdown-menu dmCUstom">
                            <li><a href="#">All</a></li>
                            <li><a href="#">Good</a></li>
                            <li><a href="#">Bad</a></li>
                        </ul>}
                    </li> */}
      </ul>
    );
  }
}
export default VerificationListSelection;



// WEBPACK FOOTER //
// ./src/components/EmailVerification/VerificationJobsList/VerificationListSelection.js